"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var toggleMessageOptionCheckbox_1 = require("../actions/toggleMessageOptionCheckbox");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_options_controls_1 = require("owa-options-controls");
var Label_1 = require("office-ui-fabric-react/lib/Label");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var MessageOptionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessageOptionsFull, _super);
    function MessageOptionsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSoundNotifyChange = function (ev, checked) {
            toggleMessageOptionCheckbox_1.default('soundNotify', checked);
        };
        _this.onEmailToastNotifyChange = function (ev, checked) {
            toggleMessageOptionCheckbox_1.default('emailToastNotify', checked);
        };
        _this.onEmptyDeletedItemsOnLogOutChange = function (ev, checked) {
            toggleMessageOptionCheckbox_1.default('emptyDeletedItemsOnLogOut', checked);
        };
        return _this;
    }
    MessageOptionsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var soundNotify = owa_options_core_1.getFallbackValueIfNull(optionStore.soundNotify, !!(userOptions.NewItemNotify & 1 /* Sound */));
        var emailToastNotify = owa_options_core_1.getFallbackValueIfNull(optionStore.emailToastNotify, !!(userOptions.NewItemNotify & 2 /* EMailToast */));
        var emptyDeletedItemsOnLogOut = owa_options_core_1.getFallbackValueIfNull(optionStore.emptyDeletedItemsOnLogOut, userOptions.EmptyDeletedItemsOnLogoff);
        return (React.createElement("div", null,
            React.createElement(Label_1.Label, null, owa_options_strings_1.default.option_mail_NotifyTitle),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: soundNotify, label: owa_options_strings_1.default.option_mail_NotifySound, onChange: this.onSoundNotifyChange }),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: emailToastNotify, label: owa_options_strings_1.default.option_mail_NotifyToast, onChange: this.onEmailToastNotifyChange }),
            React.createElement(Label_1.Label, null, owa_options_strings_1.default.option_mail_LogOutTitle),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: emptyDeletedItemsOnLogOut, label: owa_options_strings_1.default.option_mail_EmptyDeletedOnLogOut, onChange: this.onEmptyDeletedItemsOnLogOutChange })));
    };
    MessageOptionsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MessageOptionsFull);
    return MessageOptionsFull;
}(React.Component));
exports.default = MessageOptionsFull;
//# sourceMappingURL=MessageOptionsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-option/lib/components/MessageOptionsFull.js
// module id = 5055
// module chunks = 2